var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Select",
    {
      ref: "select",
      style: { width: _vm.width + (typeof _vm.width == "number" ? "px" : "") },
      attrs: {
        placeholder: _vm.$t("user." + _vm.dictionaryCategory),
        size: _vm.size,
        multiple: ["TAG1", "TAG2", "TAG3", "TAG4", "TAG5"].includes(
          _vm.dictionaryCategory
        ),
        transfer: "",
        "max-tag-count": 2,
        clearable: ""
      },
      on: { "on-change": _vm.handleChange, "on-open-change": _vm.handlerOpen },
      model: {
        value: _vm.dictinary_code,
        callback: function($$v) {
          _vm.dictinary_code = $$v
        },
        expression: "dictinary_code"
      }
    },
    _vm._l(_vm.dictionary_list, function(item, key) {
      return _c("Option", { key: key, attrs: { value: item } }, [
        _vm._v(_vm._s(item))
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5522bd47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5522bd47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dictionary_list.vue
// module id = null
// module chunks = 